var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ai-empty"},[_c('b-icon',{attrs:{"icon":_vm.icon}}),_c('h4',[_vm._v(_vm._s(_vm.title))]),_c('p',[_vm._v(_vm._s(_vm.message))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }